import { SharedService } from '../common/shared.service';
import { Injectable, Injector, NgZone, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from '../components/message/message.service';

@Injectable()
export class AppErrorHandler extends ErrorHandler {

    constructor(
        private zone: NgZone,
        private injector: Injector) {
        super();
    }

    handleError(errorResponse: HttpErrorResponse | any) {
        const router = this.injector.get(Router);
        const notificador = this.injector.get(MessageService);
        const shared = SharedService.getInstance();
        if (errorResponse instanceof HttpErrorResponse) {
            const message = errorResponse.error ? errorResponse.error : undefined;
            this.zone.run(() => {
                switch (errorResponse.status) {
                    case 0:
                        notificador.messageErro('O Servidor não respondeu. Verifique sua conexao: ' + JSON.parse(message));
                        break;
                    case 401:
                        router.navigate(['/login']);
                        shared.logout();
                        notificador.messageErro('Realize seu login novamente');
                        break;
                    case 403:
                        router.navigate(['/acesso-negado']);
                        break;
                    default:
                        notificador.messageErro(message[0] || 'Erro interno por favor, tente novamente mais tarde!');
                        break;
                }
            });
        }
        super.handleError(errorResponse);
    }

}
